document.documentElement.classList.remove('no-js');

/* Sticky header shadow ---------------------------------------------------- */
(function stickyHeader() {
  const header = document.querySelector('[data-sticky="true"]');
  if (!header) return;

  const updateShadow = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 8);
  };
  document.addEventListener('scroll', updateShadow, { passive: true });
  updateShadow();
})();

/* Age verification gate ---------------------------------------------------- */
(function ageGate() {
  const gate = document.querySelector('[data-age-gate]');
  if (!gate) return;

  const STORAGE_KEY = 'vapel_age_verified';
  if (sessionStorage.getItem(STORAGE_KEY) === 'true') return;

  gate.removeAttribute('hidden');
  document.body.style.overflow = 'hidden';

  const confirmButton = gate.querySelector('[data-age-gate-confirm]');
  if (confirmButton) {
    confirmButton.addEventListener('click', () => {
      sessionStorage.setItem(STORAGE_KEY, 'true');
      gate.setAttribute('hidden', '');
      document.body.style.overflow = '';
    });
  }
})();
